//  export const BASE_URL = 'http://localhost:4000/api/v1'
// export const BASE_URL = 'http://mern-travel-booking-api.vercel.app/'
// export const BASE_URL = 'http://kalinga-wander.vercel.app/api/v1'
export const BASE_URL = 'https://kalingawandersoriginalbackend.onrender.com/api/v1'